/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionssaving2Inputs */

const en_openquestionssaving2 = /** @type {(inputs: Openquestionssaving2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

const pt_openquestionssaving2 = /** @type {(inputs: Openquestionssaving2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A guardar…`)
};

/**
* | output |
* | --- |
* | "Saving…" |
*
* @param {Openquestionssaving2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionssaving2 = /** @type {((inputs?: Openquestionssaving2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionssaving2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionssaving2(inputs)
	return pt_openquestionssaving2(inputs)
});
export { openquestionssaving2 as "openQuestionsSaving" }